// The roles of backend/models/user.js. Portfolio managers see the portfolio
// with its instrument pages, the reports and the instrument forms; admins see
// everything. The backend enforces the same (require-portfolio-manager.js).
export const ROLE_LABELS = {
  user:              "user",
  portfolio_manager: "portfolio manager",
  admin:             "admin",
};

export const canManagePortfolio = (role) => role === "admin" || role === "portfolio_manager";
